
import { generate } from '../../../core/js/utils/componentUtils';
import { debug } from '../utils/logger';
import { checkForm, shouldActivateParsley } from '../utils/errorHandling';

import {
    sendEmailSignUpData,
    clearEmailSignUpData,
    emailSignupFailure
} from '../actions/userActions';

import { emailSignupPersonalizeSaga } from '../sagas/userSagas';

import template from 'modal/user/email-signup/email-signup-confirmation.j2';

import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import { setDefaultCountry } from '../../../core/js/utils/countryUtils';

import { fireGATrackingEvent } from '../../../core/js/utils/analyticsUtils';

import { popAllModalTransition } from '../actions/modalActions';

/**
 * Bootstrap the component onto the page
 * @param {Object} store Redux store
 * @param {Object} overrides Component-specific overrides
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const state = store.getState();
    const storeRoot = _.get(state, 'core.footer.emailSignup.email') ? 'footer' : 'modal';
    const config = {
        name: 'emailSignupConfirmationComponent',
        firstRender: firstRender,
        template: template,
        attachEvents: attachEvents,
        watch: ['core.modal.emailSignup', 'core.validations'],
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        afterRender: afterRender,
        storeRoot: storeRoot
    };
    return generate(config, store, overrides);
}

function firstRender(store) {
    this.render(store, this);
    if (shouldActivateParsley('.js-email-signup-personalize-form')) {
        attachParsley(this, store);
    }
}

function afterCloseAction(store) {
    store.dispatch(clearEmailSignUpData(this.storeRoot));
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 * @param {Object} store Redux store
 */
function attachEvents(store) {

    function handleEmailPersonalizeSignup(context) {

        const formData = {
            emailAddress: store.getState().core[context.storeRoot].emailSignup.email,
            source: store.getState().core[context.storeRoot].emailSignup.optInSource
        };
        const extraRequestData = {
            firstName: $(context.scopedSelector('[name="firstName"]')).val(),
            lastName: $(context.scopedSelector('[name="lastName"]')).val(),
            country: $(context.scopedSelector('#email-signup-country')).val(),
            postalCode: $(context.scopedSelector('[name="postalCode"]')).val()
        };
        context.attachLoader(store);
        store.runSaga(emailSignupPersonalizeSaga, formData, extraRequestData)
            .done.then((e) => {

                const payload = popAllModalTransition(e, 'emailSignupPersonalizeSaga');
                $.event.trigger({
                    type: payload.type,
                    payload: payload
                });

                fireGATrackingEvent(store, 'email signup', 'personalization complete');
                context.removeLoader(store);

            }).catch(err => {
                context.removeLoader(store);
                store.dispatch(emailSignupFailure(err, 'modal'));
            });
    }

    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-email-signup-personalize-form'), (e) => {
        debug('#email-signup-personalize-form submit');
        e.preventDefault();

        const emailSignUpFormData = _.omit(store.getState().core[this.storeRoot].emailSignup, ['messages', 'email', 'country']);
        if (!_.isEmpty(emailSignUpFormData)) {
            return handleEmailPersonalizeSignup(this);
        }
        return this.closeAction(store);

    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-modal__close'), (e) => {
        fireGATrackingEvent(store, 'email signup close', 'personalization close');
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-modal__cancel'), (e) => {
        fireGATrackingEvent(store, 'email signup no thanks', 'personalization close');
    });
}

function attachParsley(component, store) {
    debug('modal: attachParsleyForEmailSignUp');

    $(component.scopedSelector('.js-email-signup-personalize-form')).parsley()
    .on('field:validated', (e) => {
        const [values, msgs] = checkForm(component.scopedSelector('.js-email-signup-personalize-form'));

        let previousMsgs = {};
        if (store.getState().core.modal.emailSignup) {
            previousMsgs = store.getState().core.modal.emailSignup.messages;
        }

        store.dispatch(sendEmailSignUpData(_.omitBy(values, _.isEmpty), msgs, previousMsgs));
    });
}

/**
 * After render handler; currently used to set country default
 * @param {Object} store Redux store
 */
function afterRender(store) {
    const countrySelect = $(this.scopedSelector('.js-country-select'));
    setDefaultCountry(store, countrySelect);
}
